// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"833":"76b7a265","913":"1155cdd9"}[chunkId] + ".chunk.css";
};